<template>
  <div class="inner breadcrumb-wrapper" :style="{display: isHide? 'none': 'flex'}">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index) of breadList" :key="index" :to="item.path">{{item.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 是否收藏 -->
    <div class="bc-collect" v-if="userInfo">
        <span v-if="!isCollect" @click="collect"><i class="el-icon-star-off"></i>收藏</span>
        <span v-if="isCollect" @click="cancelCollect"><i class="el-icon-star-on collected"></i>已收藏</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'breadcrumb',
  data () {
    return {
      // 路由集合
      breadList: [],
      userInfo: null,
      isCollect: false,
      collectId: '',
      isHide: false // 是否隐藏面包屑
    }
  },
  created () {
    this.init()
    this.getUserInfo()
  },
  watch:{
    $route () {
      this.init()
    },
    breadCtn(newV,oldV){
    }
  },
  methods: {
    getUserInfo() {
      let userInfoJson = window.localStorage.getItem('userInfo')
      if (userInfoJson) {
        this.userInfo = JSON.parse(userInfoJson)
      }
    },
    // 判断是否包含首页路由
    isDashboard (route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return route.name === 'home' || route.name === 'homePage'
    },
    // 判断当前面包屑
    init () {
      let _this = this
      this.breadList = []
      this.$route.matched.forEach((item) => {
        if (item.meta.title) {
          if (item.name === 'infoProject') { // 知识产权项目
            let breadcrumb = _this.getBreadCtn(_this.$route.query.firstDictVal ? _this.$route.query.firstDictVal : '1')
            item.meta.title = breadcrumb
            item.path = ''
          }else if (item.name === 'intro') {
            item.meta.title = _this.$route.query.name
            if (this.$route.query.type === 'otherLink') {
              this.isHide = true
            }
          }
          this.breadList.push(item)
          if (item.parent.name && item.parent.name === 'personCenter') {
            this.breadList = [item.parent]
          }else {
            // 查看是否收藏
            this.handleCollect(item)
          }
        }
      })

      if (!this.isDashboard(this.breadList[0])) {
        this.breadList.unshift({
          path: '/',
          meta: { title: '首页' }
        })
      }
      console.log('breadList: ' , this.breadList)
    },
    getBreadCtn(selectFirst){
      var breadCtn = ''
      switch(selectFirst){
        case '1':
         breadCtn = '中国专利奖（湖北获奖项目）'
          break          
        case '2':
          breadCtn = '湖北专利奖'
          break          
        case '31':
          breadCtn = '湖北知识产权保护与转化专项'
          break     
        case '35':
          breadCtn = '知识产权护航工程'
          break          
        case '41':
          breadCtn = '我喜爱的湖北品牌电视大赛'
          break
        case '42':
          breadCtn = '湖北地理标志大会'
          break          
        case '43':
          breadCtn = '湖北省高价值专利大赛'
          break
        case '44':
          breadCtn = '“知楚杯”专利实务技能大赛'
          break
        case '5':
          breadCtn = '湖北省知识产权示范企业查询'
          break
        case '61':
          breadCtn = '全国知识产权领军人才名单'
          break
        case '62':
          breadCtn = '国家知识产权专家库'
          break
        case '63':
          breadCtn = '百千万知识产权人才工程'
          break
        case '64':
          breadCtn = '专利信息领军人才'
          break
        case '65':
          breadCtn = '全国专利信息师资人才'
          break
        case '66':
          breadCtn = '全国专利信息实务人才'
          break
        case '67':
          breadCtn = '湖北省知识产权行政保护技术调查官'
          break
        case '68':
          breadCtn = '湖北知识产权特派员'
          break          
        case '7':
          breadCtn = '中小学知识产权教育试点学校'
          break
        case '8':
          breadCtn = '省知识产权软科学研究项目立项项目'
          break
        case '9':
          breadCtn = this.$route.query.item === '2' ? '国家知识产权示范企业': '国家知识产权优势企业'
          break
        case '10':
          breadCtn = '国家知识产权强国建设试点示范'
          break          
        case '11':
          breadCtn = '全国发明展'
          break
        case '121':
          breadCtn = '先进集体'
          break
        case '122':
          breadCtn = '先进个人'
          break
        case '13':
          breadCtn = '认证专员名录'
          break
        case '14':
          breadCtn = '湖北省备案专利代理师名单'
          break
        case '15':
          breadCtn = '湖北驰名商标名录'
          break
        case '16':
          breadCtn = '湖北省专利代理师执业备案'
          break
        case '17':
          breadCtn = '湖北省地理标志专用标志使用人名单'
          break
        case '18':
          breadCtn = '湖北地理标志产品查询'
          break
        case '19':
          breadCtn = '湖北省优势商标名录'
          break
        default:
          break
      }
      return breadCtn
    },
    handleCollect(item){
      let _this = this
      let name = item.meta.title
      let url = window.location.href
      if (!this.userInfo) {
        this.getUserInfo()
      }
      if (this.userInfo) {
        let params = {
          creator: this.userInfo.id,
          name,
          url
        };
        this.$http.post(this.$http.adornUrl('/bus/data/collect/isCollect'), params).then(({ data }) => {
        if (data && data.code === 0) {
          console.log("isCollect,",data.data.isCollect)
          _this.isCollect = data.data.isCollect
          _this.collectId = data.data.id
          }
        })
      }
    },
    collect(){
      let _this = this
      let params = {
        creator: Number(this.userInfo.id),
        name: this.$route.meta.title,
        url: window.location.href
      }
      this.$http.post(this.$http.adornUrl('/bus/data/collect/save'), params).then(({ data }) => {
        if (data && data.code === 0) {
            _this.collectId = data.data
            _this.$message.success(`收藏成功`)
            _this.isCollect = true
          }
        })
    },
    cancelCollect(){
      let _this = this
      let params = {
        data: [this.collectId],
      }
      this.$http.post(this.$http.adornUrl('/bus/data/collect/delete'), params).then(({ data }) => {
        if (data && data.code === 0) {
            _this.$message.success(`取消成功`)
            _this.isCollect = false
          }
        })
    }
  }
}
</script>